import { Injectable } from '@angular/core';
import * as signalR from '@aspnet/signalr';
import { HubConnectionService } from './hub-connection.service';
import { IChatMessage } from '../../interfaces/messenger';
import { MessengerFacade } from '../../store/messenger/messenger.facade';
import { UrlBuilderService } from 'projects/communication/src/app/services';

@Injectable({
  providedIn: 'root',
})
export class SignalRMessengerService {
  private hubConnection: signalR.HubConnection;
  private counter: number;
  private reconnectionAttemptLimit: number;
  private timeoutId: NodeJS.Timeout;
  private isManualDisconnect: boolean;

  constructor(private _hubService: HubConnectionService, private _messengerFacade: MessengerFacade, private urlBuilder: UrlBuilderService) {
    this.counter = 0;
    this.reconnectionAttemptLimit = 3;
  }

  public startConnection(): void {
    if (this.hubConnection?.state === signalR.HubConnectionState.Connected) {
      return;
    }

    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(`${this.urlBuilder.socketUrl}/messenger`, {
        accessTokenFactory: () => this._hubService.getToken(),
        transport: signalR.HttpTransportType.LongPolling || signalR.HttpTransportType.ServerSentEvents,
      })
      .configureLogging(signalR.LogLevel.Information)
      .build();

    this.registerOnClose();
    this.registerOnMethods();

    this.hubConnection
      .start()
      .then(() => {
        if (this.counter > 0) {
          console.log('trigger reconnect');
          this._messengerFacade.messengerReconnection();
        }
        this.counter = 0;
        this.isManualDisconnect = false;
        console.log('Connection to the lhd-messages hub successfully initiated');
      })
      .catch((err) => {
        this.counter += 1;
        this.handleReconnection();
        console.error('Error in the SignalR handshake: lhd-messages', err);
      });
  }

  private registerOnMethods(): void {
    this.hubConnection.on('lhd-messages', (message: IChatMessage) => {
      console.log('lhd-messages');
      this._messengerFacade.newMessageReceived(message);
    });
  }

  private registerOnClose(): void {
    this.hubConnection.onclose((error) => {
      if (!this.isManualDisconnect) {
        console.log('Connection closed due to error: ', error);
        this.handleReconnection();
      }
    });
  }

  private handleReconnection(): void {
    if (this.counter <= this.reconnectionAttemptLimit) {
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(() => {
        console.log('Reconnecting lhd-messages hub, attempt: ', this.counter);
        this.startConnection();
      }, 5000);
    }
  }

  public stopConnection(): void {
    this.isManualDisconnect = true;

    this.hubConnection
      .stop()
      .then(() => {
        console.log('lhd-messages connection stopped');
        this.hubConnection = null;
        this.counter = 0;
      })
      .catch((err) => {
        console.log(`error while stopping lhd-messages connection: ${err}`);
        this.hubConnection = null;
        this.counter = 0;
      });
  }
}
